import lifeUpdates from '../../assets/Ourapp/lifeUpdates.png'
import lifeUpdatesDesktop from '../../assets/Ourapp/lifeUpdatesDesktop.png'

interface LifeUpdatesProps {
  isMobile: boolean
}

const LifeUpdates = ({ isMobile = false }: LifeUpdatesProps) => {
  return (
    <div className='w-full  my-[120px] lg:my-[186px] xl:my-[240px] 2xl:my-[300px] relative'>
      <div className='lg:w-[562.05px] lg:h-[500px] lg:rounded-[562.05px] lg:blur-[167px]  xl:w-[660px] xl:h-[587.17px] xl:rounded-[660px] xl:blur-[196px]  2xl:w-[1011.71px] 2xl:h-[900px] 2xl:rounded-[1011.71px] 2xl:blur-[300px] flex-shrink-0 bg-[#BBD2D7] absolute left-0 bottom-0'></div>

      <div
        className='flex flex-col items-center gap-1 px-[20px] self-stretch lg:flex-row lg:justify-center lg:gap-6 lg:px-0 xl:gap-8 lg:items-center 2xl:gap-10 lg:shrink-0 relative
        '
      >
        <img
          src={isMobile ? lifeUpdates : lifeUpdatesDesktop}
          className='w-[269px] h-[593px] lg:w-[500px] lg:h-[638px] xl:w-[600px] xl:h-[765px] 2xl:w-[680px] 2xl:h-[867px] 3xl:w-[743px] 3xl:h-[[948px]'
        />
        <div>
          <h2 className='text-right text-sm leading-6 tracking-wide font-bold text-[#122D5C]  lg:text-base lg:leading-7 xl:text-2xl xl:leading-9 2xl:text-4xl 2xl:leading-none 2xl:tracking-wide'>
            Lifetime updates.
          </h2>
          <p className='text-right text-[#83C8D7] font-medium text-base leading-6 tracking-wide lg:text-lg lg:leading-7 xl:text-2xl xl:leading-9 2xl:text-4xl lg:font-bold 2xl:leading-none 2xl:tracking-wide'>
            Giving you the latest at no extra cost.
          </p>
        </div>
      </div>
    </div>
  )
}

export default LifeUpdates
